import axios from './axios';

// The CSV endpoints need the Bearer header, so a plain <a href> can't fetch them:
// download through the API client as a blob and hand it to the browser.
export const downloadCsv = async (url: string, filename: string, params?: Record<string, string | undefined>) => {
  const { data } = await axios.get<Blob>(url, { params, responseType: 'blob' });
  const href = URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
};
